const SET_FLASH_MESSAGE = 'SET_FLASH_MESSAGE';
const CLEAR_FLASH_MESSAGE = 'CLEAR_FLASH_MESSAGE';

export { SET_FLASH_MESSAGE, CLEAR_FLASH_MESSAGE };
